module.exports = __webpack_public_path__ + "static/media/boost-credit-red.e5e48cbf.svg";